import { Lock, PersonOutline, PrivacyTip } from "@mui/icons-material";
import { Button, Grid, InputAdornment } from "@mui/material";
import {
  CardNumberElement,
  useElements,
  useStripe,
} from "@stripe/react-stripe-js";
import axios from "axios";
import EditFormControl from "components/form/EditFormControl";
import CustomText from "components/typography/CustomText";
import { SERVER_URL } from "lib/global";
import { useSnackbar } from "notistack";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { openLoading } from "store/reducers/tools";
import { CardCvc, CardExpiry, CardNumber } from "./PaymentCardField";
import StripeInput from "./StripeInput";

export default function CreditCardDetail({
  data = {},
  onChange = () => {},
  onNext = () => {},
}) {
  const dispatch = useDispatch();
  const stripe = useStripe();
  const elements = useElements();
  const { enqueueSnackbar } = useSnackbar();
  const [payment, setPayment] = useState({});

  const handleChangePayment = (e) => {
    setPayment((prev = {}) => ({ ...prev, [e.elementType]: e.complete }));
  };

  const handleClickPayment = async () => {
    const { cardNumber = false, cardExpiry = false, cardCvc = false } = payment;
    if (!Boolean(data?.email))
      return enqueueSnackbar("Email is required!", { variant: "warning" });
    if (!Boolean(data?.holdername))
      return enqueueSnackbar("Username is required!", { variant: "warning" });
    if (!cardNumber || !cardExpiry || !cardCvc)
      return enqueueSnackbar("Payment card is required!", {
        variant: "warning",
      });
    openLoading(true);

    const { error, paymentMethod } = await stripe.createPaymentMethod({
      type: "card",
      card: elements.getElement(CardNumberElement),
    });
    if (error) {
      openLoading(false);
      return enqueueSnackbar("Something went wrong. Try again!", {
        variant: "warning",
      });
    }
    axios
      .post(`${SERVER_URL}/api/vouchercode/create`, {
        paymentMethod: paymentMethod,
        data: { ...data, remain_boxes: +data?.box_count?.id },
      })
      .then((res) => {
        if (res.status === 200) {
          dispatch({ type: "SET_APP", payload: res.data });
          openLoading(false);
          onNext();
        }
      })
      .catch((err) => openLoading(false));
  };
  return (
    <>
      <Grid className="nofieldset" container rowSpacing={2} spacing={2}>
        <Grid item xs={12} sm={12} md={12} lg={12}>
          <EditFormControl
            name="holdername"
            placeholder="Name of Card"
            startIcon={<PersonOutline fontSize="large" color="secondary" />}
            fullWidth
            required
            value={data?.holdername ?? ""}
            onChange={onChange}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={12}>
          <EditFormControl
            name="ccnumber"
            required
            fullWidth
            InputLabelProps={{ shrink: true }}
            InputProps={{
              inputComponent: StripeInput,
              inputProps: {
                component: CardNumber,
              },
              endAdornment: (
                <InputAdornment position="end">
                  <Lock color="secondary" />
                </InputAdornment>
              ),
            }}
            onChange={handleChangePayment}
          />
        </Grid>
        <Grid item xs={6} sm={6}>
          <EditFormControl
            name="ccexp"
            variant="outlined"
            required
            fullWidth
            InputLabelProps={{ shrink: true }}
            InputProps={{
              inputComponent: StripeInput,
              inputProps: {
                component: CardExpiry,
              },
            }}
            onChange={handleChangePayment}
          />
        </Grid>
        <Grid item xs={6} sm={6}>
          <EditFormControl
            name="cvc"
            variant="outlined"
            required
            fullWidth
            InputLabelProps={{ shrink: true }}
            InputProps={{
              inputComponent: StripeInput,
              inputProps: {
                component: CardCvc,
              },
              endAdornment: (
                <InputAdornment position="end">
                  <PrivacyTip color="secondary" />
                </InputAdornment>
              ),
            }}
            onChange={handleChangePayment}
          />
        </Grid>
      </Grid>
      <CustomText className="font-zing text-white text-3xl pt-8">
        One-Off Payment:{" "}
        {data?.box_count?.id
          ? `$${data?.box_count?.id === 1 ? 73 : data?.box_count?.id * 65}`
          : ""}
      </CustomText>
      <Button
        className="uppercase px-6 mt-4 text-2xl font-zing"
        variant="contained"
        onClick={handleClickPayment}
      >
        Confirm Payment
      </Button>
    </>
  );
}
